function initCasesSlider() {
  const sliderElement = document.getElementById('casesSlider');
  if (!sliderElement) return;

  new Swiper(sliderElement, {
    modules: [SwiperPagination, SwiperNavigation],
    slidesPerView: 1,
    spaceBetween: 24,
    centeredSlides: true,
    loop: false,
    grabCursor: true,
    
    pagination: {
      el: '.cases__pagination',
      clickable: true,
    },

    navigation: {
      prevEl: '#casesPrev',
      nextEl: '#casesNext',
    },

    breakpoints: {
      // На планшетах показываем 1.5 слайда (подсказка «листай дальше»)
      768: {
        slidesPerView: 1.15,
        spaceBetween: 32,
        centeredSlides: true,
      },
      // На десктопе — строго 1 слайд по центру
      992: {
        slidesPerView: 1,
        spaceBetween: 40,
        centeredSlides: true,
      },
    },
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initCasesSlider();
});